import { Component, OnInit } from '@angular/core';
import { AuthService } from "../../services/auth.service";
import { ErrorStateMatcher } from '@angular/material/core';
import { FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';

/** Error when invalid control is dirty, touched, or submitted. */
export class UserErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {

  // matcher errors
  public matcher = new UserErrorStateMatcher();

  constructor(
    public authService: AuthService,
    private fb: FormBuilder
  ) { }

  // Create UserAuth Form
  public userFormAuth: FormGroup = this.fb.group({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required])
  });

  ngOnInit() {
    this.userFormAuth.controls.email.setValue("");
    this.userFormAuth.controls.password.setValue("");
  }

}